﻿$.fn.dxCtrlMenuPlaniti = function custom_dxCtrlMenuPlaniti(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlmenuplaniti dx-ctrl");
        this.createInstance(new cdxCtrlMenuPlaniti(this, option));
    }
    return this;
}

window.cdxCtrlMenuPlaniti = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    if (typeof option.context_grid == 'undefined') option.context_grid = "menu_planiti"
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid] = {}

    function mConstruit() {
        container.empty();

        var ds = [{ id: 0, text: "Agenda réunion Planiti", selected: true }]
        if (option.bddCtrl.objCptCli.objetMetier.hasAgenda()) {
            ds.push({ id: 1, text: "Votre agenda utilisateur" })
        }
        ds.push({ id: 2, text: "Liste évènements" })
        ds.push({ id: 3, text: "Liste réunion" })
        //if (!mDsIsEgale(ds, option.bddCtrl.utiCourantParaJson[option.context_grid].dsmenu)) option.bddCtrl.utiCourantParaJson[option.context_grid].dsmenu = ds
        //lst = []
        //ds.forEach(function (item) {
        //    lst.push(item)
        //    lst = lst.concat(mGetLstItemTreeview(item))
        //})
        //lst.forEach(function (item) { mInitFromSaveTreeview(item, option.bddCtrl.utiCourantParaJson[option.context_grid].dsmenu, null, "id") })
        if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].dsmenu == 'undefined') {
            option.bddCtrl.utiCourantParaJson[option.context_grid] = { dsmenu: JSON.parse(JSON.stringify(ds)) }
            option.bddCtrl.mSaveParaJsonUtilisateur();
        }
        option.bddCtrl.utiCourantParaJson[option.context_grid].dsmenu.forEach(function (item) {
            var currentItem = ds.filter(function (o) { return ((o.id) ? o.id.toString() : o.id) == ((item.id) ? item.id.toString() : item.id) })[0]
            if (typeof currentItem != 'undefined') {
                currentItem.selected = ((typeof item.selected == 'undefined') ? false : item.selected)
                currentItem.expanded = ((typeof item.expanded == 'undefined') ? false : item.expanded)
            }
        })

        var dxTreeViewMenu = $("<div/>").appendTo(container).dxTreeView({
            dataSource: ds,
            width: "100%",
            height: "auto",
            focusStateEnabled: true,
            selectionMode: "single",
            //showCheckBoxesMode: true,
            onItemClick: function (e) {
                dxTreeViewMenu.selectItem(e.itemData)
            },
            onItemSelectionChanged: function (e) {
                e.component.element().find(".dx-treeview-item").css("background-color", "");
                $(e.itemElement).css("background-color", theme.backgroundcolorAccentSelect);
                Me.mSelect(((e.component.getSelectedNodes().length == 0) ? null : e.component.getSelectedNodes()[0].itemData))
                option.bddCtrl.utiCourantParaJson[option.context_grid].dsmenu = e.component.option("dataSource")
                option.bddCtrl.mSaveParaJsonUtilisateur();
            },
            itemTemplate: function (itemData, itemIndex, itemElement) {
                var $Table = $("<table/>").appendTo(itemElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:1px;font-size:160%;padding-right:5px;'/>").appendTo($Tr)
                switch (itemIndex) {
                    case 0: $("<i class='fas fa-share-nodes'></i>").appendTo($Td); break;
                    case 1: $("<i class='fas fa-calendar-week'></i>").appendTo($Td); break;
                    case 2: $("<i class='fas fa-share-nodes'></i>").appendTo($Td); break;
                    case 3: $("<i class='fas fa-square-share-nodes'></i>").appendTo($Td); break;
                }
                var $Td = $("<td style='width:100%;white-space:nowrap;'>" + itemData.text + "</td>").appendTo($Tr)
            },
            onContentReady: function (e) {
                e.element.find('.dx-scrollable').dxScrollable('instance').option({
                    'disabled': 'true',
                    "showScrollbar": "never"
                });
                e.element.find(".dx-treeview-expander-icon-stub").hide()
                e.element.find(".dx-treeview-node").css("papdding-left","0")
                $(e.component.element().find(".dx-state-selected").children()[0]).css("background-color", theme.backgroundcolorAccentSelect);
                Me.mSelect(((e.component.getSelectedNodes().length == 0) ? null : e.component.getSelectedNodes()[0].itemData))

            }
        }).dxTreeView('instance');
    }

    this.mSelect = function (itemData) {
        option.onSelectChange(itemData)
    }

    this.element = function () { return container; }

    mConstruit();
}